<template>
  <div class='StorageCardSale'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>
    <Table :TableParam="Table">
        <template v-slot:BtnSlot>
            <el-button size="small" @click="exportFun">导出</el-button>
            <el-button type="primary" size="small" @click="saleFun">售卡</el-button>
        </template>
        <template v-slot:orderStatus="{ item }">
          <span>{{ $label.getLabel($label.OrderStatus, item.orderStatus)}}</span>
        </template>
        <template v-slot:handle="{ item }">
            <el-link type="primary" @click="detailFun(item.id)">详情</el-link>
            <el-divider direction="vertical" v-if="item.orderStatus === 2 && item.isOperation"></el-divider>
            <el-link type="primary" @click="sendFun(item.id)" v-if="item.orderStatus === 2 && item.isOperation">发卡</el-link>
            <el-divider direction="vertical" v-if="item.orderStatus === 2 && item.isOperation"></el-divider>
            <el-link type="primary" @click="deleteFun(item.id)" v-if="item.orderStatus === 2 && item.isOperation">删除</el-link>
        </template>
        <template v-slot:Paging>
            <Paging @change="getItemList"
                    :pager="pager" />
        </template>
    </Table>
    <Modal :show.sync="isShow" 
           :info="info" 
           :type="type"
           @getList="getItemList"
           v-if="isShow"/>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import Modal from './components/Modal.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    Modal
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '订单编号：', prop: 'orderSn', placeholder: '请输入订单编号' },
          { type: 'Input', label: '操作人员：', prop: 'updater', placeholder: '请输入操作人员' },
          { type: 'Input', label: '合同编号：', prop: 'contactSn', placeholder: '请输入合同编号' },
          { type: 'Input', label: '购买人：', prop: 'customerName', placeholder: '请输入购买人' },
          { type: 'Date', label: '更新日期：', prop: 'updateDate', placeholder: '请选择更新日期' },
          { type: 'Select', label: '订单状态：', prop: 'orderStatus', options: this.$label.OrderStatus, placeholder: '请选择订单状态' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      type: 0, 
      info: null,
      isShow: false,
      Table: { // 表格
        paddingRight: true,
        btnSlot: true,
        handle: true,
        data: [],
        column: [
          { prop: 'orderSn', label: '订单号' },
          { prop: 'cardNum', label: '卡数量' },
          { prop: 'orderAmount', label: '订单金额' },
          { prop: 'updater', label: '操作人员' },
          { prop: 'customerName', label: '购买人' },
          { prop: 'adjustAmount', label: '售卖调整价' },
          { prop: 'contactSn', label: '合同编号' },
          { prop: 'orderStatus', label: '订单状态', slot: true },
          { prop: 'updateDate', label: '更新日期' }
        ]

      }
    }
  },
  // 方法集合
  methods: {
    searchHandleForm () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },
    // 导出
    exportFun () {
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.exportSaleCardApi(params).then(res => {
        this.$message.success(res.msg)
      })
    },
    saleFun () {
      this.showModal(0)
    },
    // 详情
    detailFun (id) {
      this.$http.detailSaleCardApi({ id }).then(res => {
        this.info = res.data
        this.showModal(1)
      })
    },
    // 发卡
    sendFun (id) {
      this.$http.detailSaleCardApi({ id }).then(res => {
        this.info = res.data
        this.showModal(2)
      })
    },
    showModal (type) {
      this.type = type
      this.isShow = true
    },
    // 删除订单
    deleteFun (id) {
      this.$confirm('确认当前操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteOrderCardApi({ orderId: id }).then(res => {
          this.getItemList()
          this.$message.success(res.msg)
        })
      })
    },
    getItemList () {
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getStoreCardSaleListApi(params).then(res => {
        pager.count = res?.data?.total || 0
        Table.data = res?.data?.list || []
      })
    },
    init () {
      this.getItemList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },

}
</script>
<style lang='scss' scoped>
</style>
